import React from "react";

const LocationIcon: React.FC = () => {

    return (
        <svg version="1.1"
             xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 14 14"
             enableBackground="new 0 0 14 14"
             xmlSpace="preserve"
        >
            <g transform="translate(0,-952.36218)">
                <path
                    fill="#297EAB"
                    d="M6.6,952.4v1.7c-2.6,0.2-4.7,2.3-4.9,4.9H0v0.9h1.7c0.2,2.6,2.3,4.7,4.9,4.9v1.7h0.9v-1.7
		c2.6-0.2,4.7-2.3,4.9-4.9H14v-0.9h-1.7c-0.2-2.6-2.3-4.7-4.9-4.9v-1.7H6.6z M6.5,954.9C6.5,954.9,6.6,954.9,6.5,954.9l0,1.6h0.9
		v-1.6c2.1,0.2,3.8,1.9,4,4H9.8v0.9h1.6c-0.2,2.1-1.9,3.8-4,4v-1.6H6.6v1.6c-2.1-0.2-3.8-1.9-4-4h1.6v-0.9H2.6
		C2.8,956.8,4.4,955.1,6.5,954.9L6.5,954.9z M7,957.6c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S8,957.6,7,957.6z
		 M7,958.5c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9S6.5,958.5,7,958.5z"
                />
            </g>
        </svg>
    )

}

export default LocationIcon;